module.exports = __webpack_public_path__ + "media/svg/xk-859f3ba6.svg";